<template>
  <div class="steps-panel-wrapper">
    <StepsBar :steps="steps" :current-step="currentStepEff" @step-clicked="onStepClick" v-show="steps.length > 1" />
    <div class="steps-panel-content">
      <DxTabPanel
        :data-source="steps"
        :selected-index="currentStepEff - 1"
        :loop="false"
        :animation-enabled="false"
        :swipe-enabled="false"
        :show-nav-buttons="false"
        @selection-changed="onSelectionChanged"
        class="steps-dx-tabpanel"
      >
        <template #item="{ data: step }">
          <component
            :is="step.component"
            :ref="step.ref || null"
            v-bind="stepPropsFn ? stepPropsFn(step) : {}"
            @input="(val) => onStepInput(step, val)"
          />
        </template>
      </DxTabPanel>
    </div>
  </div>
</template>

<script>
import DxTabPanel from "devextreme-vue/tab-panel";
import StepsBar from "./StepsBar.vue";

export default {
  name: "StepsPanelWrapper",
  components: {
    DxTabPanel,
    StepsBar,
  },
  props: {
    steps: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: Number,
      default: null,
    },
    stepPropsFn: {
      type: Function,
      default: null,
    },
    registerRef: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      innerStep: this.currentStep || 1,
    };
  },
  computed: {
    currentStepEff() {
      return this.currentStep || this.innerStep || 1;
    },
  },
  watch: {
    currentStep(val) {
      if (Number.isFinite(val) && val !== this.innerStep) {
        this.innerStep = val;
      }
    },
  },
  methods: {
    onStepClick(stepNumber) {
      // Validate current step before moving forward
      if (stepNumber > this.currentStepEff) {
        const currentStep = this.steps.find(s => s.number === this.currentStepEff);
        if (currentStep && currentStep.ref) {
          const stepComponent = this.$refs?.[currentStep.ref];
          if (stepComponent && typeof stepComponent.validate === "function") {
            const errors = stepComponent.validate();
            if (errors && errors.length > 0) {
              const errorMsg = errors[0] || (this.$t ? this.$t("fill_out_error") : "Please fill out all required fields");
              this.$emit("validation-error", { message: errorMsg, stepNumber: this.currentStepEff });
              return; // Don't change step if validation fails
            }
          }
        }
      }
      
      this.innerStep = stepNumber;
      this.$emit("update:currentStep", stepNumber);
      this.$emit("step-change", stepNumber);
    },
    onSelectionChanged(e) {
      if (e.addedItems && e.addedItems.length > 0) {
        const next = e.addedItems[0].number;
        this.innerStep = next;
        this.$emit("update:currentStep", next);
        this.$emit("step-change", next);
      }
    },
    onStepInput(step, payload) {
      this.$emit("step-input", step, payload);
    },
    async validateSteps() {
      const errors = [];
      if (!Array.isArray(this.steps)) {
        return errors;
      }
      for (const step of this.steps) {
        if (!step || !step.ref) {
          continue;
        }
        const comp = this.$refs?.[step.ref];
        const validator = comp && typeof comp.validate === "function" ? comp.validate : null;
        if (validator) {
          const res = await Promise.resolve(validator());
          if (Array.isArray(res)) {
            errors.push(...res);
          } else if (res === false) {
            errors.push(this.$t ? this.$t("fill_out_error") : "fill out error");
          }
        }
      }
      return errors;
    },
  },
};
</script>

<style scoped>
.steps-panel-wrapper {
  flex: 1;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.steps-panel-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: 100%;
}

.steps-dx-tabpanel {
  width: 100%;
  height: 100%;
  min-height: 300px;
}
</style>

<style>
.steps-panel-content .dx-tabpanel-tabs {
  display: none !important;
}

.steps-panel-content .dx-multiview-wrapper {
  border: none !important;
}

.steps-panel-wrapper .dx-selectbox,
.steps-panel-wrapper .dx-textbox {
  margin-top: 8px !important;
}
</style>